import {faPlus} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Flex, Space, Tag, Tooltip} from 'antd';
import {useState} from 'react';

import {Locale} from '../../../../provider/locale/localization';
import {mergeBulkTagsIntoReview} from '../../../../service/reviews/reviews-bulk-tags-merge';
import {ReviewDataTagType} from '../../../../service/reviews/reviews-type';
import {TagsPopup} from '../tags-popup/tags-popup';

import * as styles from './review-tags-select.module.scss';

type PropsType = {
    value?: Array<ReviewDataTagType>;
    onChange?: (value: Array<ReviewDataTagType>) => void;
};

export function ReviewTagsSelect(props: PropsType): JSX.Element {
    const {value = [], onChange} = props;

    const [isTagsPopupOpen, setIsTagsPopupOpen] = useState<boolean>(false);

    function handleRemoveTag(id: number): void {
        onChange?.(value.filter((tag) => tag.id !== id));
    }

    return (
        <>
            <Flex className={styles.ReviewTagsSelect_tagsContainer}>
                {value.map((tag) => {
                    const {id, title, isAspect} = tag;

                    return (
                        <Tooltip key={id} title={isAspect ? <Locale stringKey="REVIEW__AUTO_TAG__TITLE" /> : ''}>
                            <Tag closable onClose={() => handleRemoveTag(id)}>
                                {title}
                            </Tag>
                        </Tooltip>
                    );
                })}
                <Tag className={styles.ReviewTagsSelect_addTagButton} onClick={() => setIsTagsPopupOpen(true)}>
                    <Space size={4}>
                        <FontAwesomeIcon icon={faPlus} />
                        <Locale stringKey="REVIEWS__REVIEW__ADD_TAG" />
                    </Space>
                </Tag>
            </Flex>

            {isTagsPopupOpen && (
                <TagsPopup
                    currentTags={value}
                    isCreating={false}
                    isOpen
                    onApply={(newTags) => {
                        onChange?.(mergeBulkTagsIntoReview(value, newTags));
                        setIsTagsPopupOpen(false);
                    }}
                    onClose={() => setIsTagsPopupOpen(false)}
                />
            )}
        </>
    );
}
